import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource, MatSnackBar } from '@angular/material';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Handle } from '../../../handle';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Md5 } from 'ts-md5/dist/md5';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Component({
  selector: 'app-create-distribuidor',
  templateUrl: './create-distribuidor.component.html',
  styleUrls: ['./create-distribuidor.component.scss']
})
export class CreateDistribuidorComponent implements OnInit {

  displayedColumns = ['NOMBRE', 'BORRAR'];

  listaSub = [];
  dataSource;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private localSave: LocalSaveService,
    private dialogRef: MatDialogRef<CreateDistribuidorComponent>, public Handle: Handle, private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar, private gateway: GatewayService) { }
  operacion = 'createdistribuidor';
  iddistribuidor = '';
  idpais;

  ngOnInit() {
    this.idpais = this.data.distribuidor.IDPAIS;
    if (this.data.operacion == 'Editar') {
      let SUBS = {
        IDDISTRIBUIDOR: this.data.distribuidor.iddistribuidor
      }
      this.operacion = 'editdistribuidor';
      this.iddistribuidor = this.data.distribuidor.iddistribuidor;
      this.grupoVal.controls.NOMBRE.setValue(this.data.distribuidor.nombre);
      this.grupoVal.controls.CAPMAXAM.setValue(this.data.distribuidor.am_capacity);
      this.grupoVal.controls.CAPMAXPM.setValue(this.data.distribuidor.pm_capacity);
      this.grupoVal.controls.TIPO.setValue(this.data.distribuidor.tipo);
      this.grupoVal.controls.CORREO.setValue(this.data.distribuidor.correo);
      this.grupoVal.controls.AUTORIZACION.setValue(this.data.distribuidor.autorizacion_auto);
      this.grupoVal.controls.AUTORIZACION_DUPLICADO.setValue(this.data.distribuidor.autorizacion_duplicado);
      this.grupoVal.controls.PASS.setValue(this.data.distribuidor.password);
      this.grupoVal.controls.PASS2.setValue(this.data.distribuidor.password);
      this.grupoVal.controls.REPRESENTANTE.setValue(this.data.distribuidor.representante_legal);
      this.grupoVal.controls.CONTACTO1.setValue(this.data.distribuidor.contacto1);
      this.grupoVal.controls.CONTACTO2.setValue(this.data.distribuidor.contacto2);
      this.grupoVal.controls.CANTCARROS.setValue(this.data.distribuidor.cantidad_carros);
      this.grupoVal.controls.FECHAINI.setValue(this.data.distribuidor.fechaini);
      this.grupoVal.controls.FECHAFIN.setValue(this.data.distribuidor.fechafin);

      // this.dataSource = new MatTableDataSource<any>(this.listaSub);
      this.onInputChange();
    }
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  save() {
    let md5 = new Md5();
    this.spinner.show();
    let DISTRIBUIDOR = {
      IDDISTRIBUIDOR: this.iddistribuidor,
      NOMBRE: this.grupoVal.controls.NOMBRE.value.trim(),
      CAPMAXAM: this.grupoVal.controls.CAPMAXAM.value,
      CAPMAXPM: this.grupoVal.controls.CAPMAXPM.value,
      TIPO: this.grupoVal.controls.TIPO.value,
      CORREO: this.grupoVal.controls.CORREO.value,
      AUTORIZACION: this.grupoVal.controls.AUTORIZACION.value ? 1 : 0,
      AUTORIZACION_DUPLICADO: this.grupoVal.controls.AUTORIZACION_DUPLICADO.value ? 1 : 0,
      PASS: md5.appendStr(this.grupoVal.controls.PASS.value).end(),
      IDPAIS: this.idpais,
      IDPADRE: this.localSave.get('usuarioPGV').IDU,
      IDAREA: this.localSave.get('usuarioPGV').IDAREA,

      REPRESENTANTE: this.grupoVal.controls.REPRESENTANTE.value,
      CONTACTO1: this.grupoVal.controls.CONTACTO1.value,
      CONTACTO2: this.grupoVal.controls.CONTACTO2.value,
      CANTCARROS: this.grupoVal.controls.CANTCARROS.value,
      FECHAINI: this.grupoVal.controls.FECHAINI.value,
      FECHAFIN: this.grupoVal.controls.FECHAFIN.value
    }

    if (this.data.operacion == 'Editar' && this.grupoVal.controls.PASS.value == this.data.distribuidor.password) {
      // alert('entra')
      DISTRIBUIDOR.PASS = this.grupoVal.controls.PASS.value;
    }

    // console.log('========')
    //   console.log(this.operacion)
    // console.log(DISTRIBUIDOR)
    //   console.log('/=/=======')
    this.gateway.save(this.operacion, DISTRIBUIDOR).then((result) => {
      // console.log('========')
      // console.log(result)
      // console.log('/=/=======')
      this.spinner.hide();
      this.dialogRef.close(true);
    }
    ).catch(function (e) {
    });
  }

  passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?["."#?!@$%^&*-])/;
  grupoVal = new FormGroup({
    NOMBRE: new FormControl('', [Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(30),
      Validators.pattern("[/ a-z A-Z ñÑáéíóúÁÉÍÓÚ]+[0-9a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])]),
    TIPO: new FormControl('', [Validators.compose([
      Validators.required
    ])]),

    REPRESENTANTE: new FormControl('', [Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(250), Validators.pattern("[/ a-z A-Z ñÑáéíóúÁÉÍÓÚ]+[0-9a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])]),
    CONTACTO1: new FormControl('', [Validators.compose([
      Validators.required, Validators.pattern('[2-9]{1}[0-9]{7}')
    ])]),
    CONTACTO2: new FormControl('', [Validators.compose([
      Validators.required, Validators.pattern('[2-9]{1}[0-9]{7}')
    ])]),
    CANTCARROS: new FormControl('', [Validators.compose([Validators.required, Validators.pattern('[0-9]+')])]),
    FECHAINI: new FormControl('', [Validators.compose([Validators.required])]),
    FECHAFIN: new FormControl('', [Validators.compose([Validators.required])]),

    CORREO: new FormControl('', Validators.compose([
      Validators.required, Validators.pattern("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")
    ])),
    PASS: new FormControl('', Validators.compose([
      Validators.required, Validators.minLength(8), Validators.pattern(this.passwordRegex)
    ])),
    PASS2: new FormControl('', Validators.compose([
      Validators.required, Validators.minLength(8), Validators.pattern(this.passwordRegex)
    ])),
    CAPMAXAM: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXPM: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    AUTORIZACION: new FormControl(true),
    AUTORIZACION_DUPLICADO: new FormControl(true)
  });

  tipos = [
    { ID: 1, NOMBRE: 'Interno' },
    { ID: 2, NOMBRE: 'Externo' }
  ];

  onValueChanged(option: any): void {
    // Aquí puedes ejecutar la lógica deseada
    if (option == 2) {
      if (this.data.operacion == 'Editar') {
        this.grupoVal.get('PASS').setValidators(Validators.compose([
          Validators.required, Validators.minLength(8)
        ]))
        this.grupoVal.get('PASS').updateValueAndValidity();
        this.grupoVal.get('PASS2').setValidators(Validators.compose([
          Validators.required, Validators.minLength(8)
        ]))
        this.grupoVal.get('PASS2').updateValueAndValidity();
      } else {
        this.grupoVal.get('PASS').setValidators(Validators.compose([
          Validators.required, Validators.minLength(8), Validators.pattern(this.passwordRegex)
        ]))
        this.grupoVal.get('PASS').updateValueAndValidity();
        this.grupoVal.get('PASS2').setValidators(Validators.compose([
          Validators.required, Validators.minLength(8), Validators.pattern(this.passwordRegex)
        ]))
        this.grupoVal.get('PASS2').updateValueAndValidity();
      }
    } else {
      this.grupoVal.get('PASS').setValidators(Validators.compose([]))
      this.grupoVal.get('PASS').updateValueAndValidity();
      this.grupoVal.get('PASS2').setValidators(Validators.compose([]))
      this.grupoVal.get('PASS2').updateValueAndValidity();
    }
  }

  onInputChange() {
    if (this.data.operacion == 'Editar'
      && this.grupoVal.controls.PASS.value != ''
      && this.grupoVal.controls.PASS.value == this.data.distribuidor.password) {
      this.grupoVal.get('PASS').setValidators(Validators.compose([
        Validators.required, Validators.minLength(8)
      ]))
      this.grupoVal.get('PASS').updateValueAndValidity();
      this.grupoVal.get('PASS2').setValidators(Validators.compose([
        Validators.required, Validators.minLength(8)
      ]))
      this.grupoVal.get('PASS2').updateValueAndValidity();
    } else {
      this.grupoVal.get('PASS').setValidators(Validators.compose([
        Validators.required, Validators.minLength(8), Validators.pattern(this.passwordRegex)
      ]))
      this.grupoVal.get('PASS').updateValueAndValidity();
      this.grupoVal.get('PASS2').setValidators(Validators.compose([
        Validators.required, Validators.minLength(8), Validators.pattern(this.passwordRegex)
      ]))
      this.grupoVal.get('PASS2').updateValueAndValidity();
    }
  }

}
